import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Spin } from "antd";
import PhoneInput from "react-phone-number-input";
import phoneIcon from "../../../../../../assets/images/phone.svg";
import whatsappIcon from "../../../../../../assets/images/watsapp.svg";
import webIcon from "../../../../../../assets/images/website.svg";
import mailIcon from "../../../../../../assets/images/mail.svg";
import "./PersonalInfoForm.scss";
import userServiceApi from "../../../../../../api/userServiceApi";
import { toast } from "react-toastify";
import {
  getRequest,
  postRequest,
  putRequest,
} from "../../../../../../api/http";
import { useLocation } from "react-router-dom";

const PersonalInfoForm = ({ tabKey }) => {
  const location = useLocation();
  const micrositeId = location.pathname.split("/")[1];
  const tabConfigId = localStorage.getItem("selectedTabId");

  const [form] = Form.useForm();

  const [disabledSave, setDisabledSave] = useState(true);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getTabInfo = async () => {
    setLoading(true);
    try {
      const res = await getRequest(
        userServiceApi.getContactUsDetails(tabKey, micrositeId)
      );
      const data = res?.data[0];
      setData(data);
      form.setFieldsValue({
        phone: data?.phone || "",
        email: data?.email || "",
        whatsapp: data?.chatNumber || "",
        website: data?.websiteLink || "",
      });
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
    setLoading(false);
  };

  const renderLabel = (iconSrc, labelText) => (
    <div className="align-div-items-center">
      <div className="min-width-24">
        <img src={iconSrc} alt={labelText} className="margin-right-3" />
      </div>
      {labelText}
    </div>
  );

  const handleSave = async (values) => {
    try {
      const payload = {
        phone: values.phone,
        email: values.email,
        chatNumber: values.whatsapp,
        websiteLink: values.website,
        contactUsTypeEnum: tabKey,
      };
      if (data?.id) {
        payload.contactUsId = data?.id;
        const res = await putRequest(
          userServiceApi.updateContactUsSales(data?.id),
          payload
        );
        if (res) {
          toast.success("Updated successfully");
        }
      }
      if (!data?.id) {
        const res = await postRequest(
          userServiceApi.addContactUsDetails(micrositeId, tabConfigId),
          payload
        );
        if (res) {
          toast.success("Created successfully");
        }
      }
      getTabInfo();
      setDisabledSave(true);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleFormChange = () => {
    setDisabledSave(
      form.isFieldsTouched() &&
        form.getFieldsError().some(({ errors }) => errors.length)
    );
  };

  useEffect(() => {
    if (tabKey && micrositeId) {
      getTabInfo();
    }
  }, [tabKey, micrositeId]);

  if (loading) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  return (
    <Col span={15}>
      <Form
        form={form}
        initialValues={{}}
        layout="horizontal"
        onFinish={handleSave}
        className="personal-form"
        onFieldsChange={handleFormChange}
      >
        <Form.Item
          label={renderLabel(phoneIcon, "Phone")}
          labelCol={{ span: 4 }}
          name="phone"
          rules={[{ required: true, message: "Please enter phone number." }]}
        >
          <PhoneInput
            className="custom-phone-input"
            defaultCountry="GB"
            placeholder="Enter phone number"
            focusInputOnCountrySelection
          />
        </Form.Item>
        <Form.Item
          label={renderLabel(mailIcon, "Email")}
          labelCol={{ span: 4 }}
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter email address.",
            },
          ]}
        >
          <Input placeholder="Enter email address" />
        </Form.Item>
        <Form.Item
          label={renderLabel(whatsappIcon, "Whatsapp")}
          labelCol={{ span: 4 }}
          name="whatsapp"
        >
          <Input placeholder="Enter whatsapp number" />
        </Form.Item>
        <Form.Item
          label={renderLabel(webIcon, "Website")}
          labelCol={{ span: 4 }}
          name="website"
          rules={[
            {
              required: true,
              message: "Please enter website.",
            },
          ]}
        >
          <Input placeholder="Enter website" />
        </Form.Item>
        <Form.Item>
          <div className="align-div-items-end">
            <Button
              disabled={disabledSave}
              className={`saveBtn greenBtn ${
                disabledSave ? "save-btn-disabled" : ""
              }`}
              htmlType="button"
              onClick={() => form.submit()}
            >
              Save
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Col>
  );
};

export default PersonalInfoForm;
